var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-card',[_c('v-toolbar',{attrs:{"color":"red","dark":""}},[_c('v-toolbar-title',[_vm._v("ALBUM")])],1),_c('div',{staticClass:"images-brick-layout"},_vm._l((_vm.filteredimages),function(image_url,index){return _c('brick-layout-photo',{key:index,attrs:{"image_url":image_url}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }